import { AdminPanel } from './config';

export const SERVER_PATH = `${AdminPanel}api/`;
